const animations = {
  rotate: `
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  `,
  fadeout: `
    from { opacity: 1; }
    to   { opacity: 0.25; }
  `,
};

export default animations;
